// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './tools/router'
import store from './tools/store'
import VueLocalStorage from 'vue-ls'
import parseModel from '../parse-model/vuePlugin'
import authManager from './tools/auth/authManager'
import parseConfig from '../config/parse.js'
import '../scss/custom.scss'
import AsyncComputed from 'vue-async-computed'
import 'vue-material-design-icons/styles.css'
import DataManager from './tools/data/dataManager'

import vuexI18n from 'vuex-i18n'
import translationsEn from './tools/i18n/en'
import translationsFr from './tools/i18n/fr'
import translationsEs from './tools/i18n/es'

require('bootstrap')

Vue.config.productionTip = false

Vue.use(AsyncComputed)

console.log('parseConfig', parseConfig)
if (router.resolve(router.history.getCurrentLocation()).location.query.test) {
  Vue.use(parseModel, { appId: parseConfig.appIdTest, serverUrl: parseConfig.serverUrlTests })
} else {
  Vue.use(parseModel, { appId: parseConfig.appId, serverUrl: parseConfig.serverUrl })
}
Vue.use(authManager, { router: router, store: store })
Vue.use(VueLocalStorage)
Vue.use(DataManager, { $vueParse: Vue['vueParse'], $store: store, $ls: Vue['ls'] })
Vue.use(vuexI18n.plugin, store)

Vue.i18n.add('en', translationsEn)
Vue.i18n.add('fr', translationsFr)
Vue.i18n.add('es', translationsEs)

Vue.i18n.set('en') // set the start locale to use

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  parseModel,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js